<template>
  <div class="loading_container" v-if="error !== null">
    <div class="alert alert-danger m-5" v-if="error.errorCode === 'ASSISTANT_NOT_FOUND'">
      O perfil de assistente que você tentou acessar não foi encontrado.
    </div>

    <div
      class="alert alert-danger m-5"
      v-else-if="error.errorCode === 'CLIENT_NOT_FOUND'"
    >
      O perfil de cliente que você tentou acessar não foi encontrado.
    </div>

    <div
      class="alert alert-danger m-5"
      v-else-if="error.errorCode === 'PROJECT_NOT_FOUND'"
    >
      O projeto que você tentou acessar não foi encontrado.
    </div>

    <div
      class="alert alert-danger m-5"
      v-else-if="error.errorCode === 'PROPOSAL_NOT_FOUND'"
    >
      A proposta que você tentou acessar não foi encontrada.
    </div>

    <div class="alert alert-danger m-5" v-else>
      Ocorreu um erro ao processar sua requisição. Verifique sua conexão e tente
      novamente.<br /><br />
      Se o problema persistir, por favor, contate o suporte via
      <a class="link" href="mailto:suporte@virtap.com.br" target="_blank"
        >suporte@virtap.com.br</a
      >.
    </div>
  </div>
  <router-view v-else></router-view>
</template>

<script>
export default {
  components: {},

  computed: {
    section() {
      return this.$store.state.activeSection;
    },
    error() {
      return this.$store.state.error;
    },
  },
  data() {
    return {};
  },

  methods: {},

  watch: {
    section(newValue, oldValue) {
      let title = "Virtap | Admin";

      switch (newValue) {
        case "LoginPage":
          title += " | Login";
          break;
        case "DashboardPage":
          title += " | Dashboard";
          break;
        case "AssistantListPage":
          title += " | Assistentes";
          break;
        case "ClientListPage":
          title += " | Clientes";
          break;
        case "ProjectListPage":
          title += " | Projetos";
          break;
        case "ProposalListPage":
          title += " | Propostas";
          break;
        case "AssistantPage":
          title += " | Assistente";
          break;
        case "ClientPage":
          title += " | Cliente";
          break;
        case "ProjectPage":
          title += " | Projeto";
          break;
        case "ProposalPage":
          title += " | Proposta";
          break;
          case "VideoListPage":
          title += " | Aulas e Mentorias";
          break;
          case "VideoPage":
          title += " | Aulas e Mentorias | Aula/Mentoria";
          break;
          case "CourseListPage":
          title += " | Cursos";
          break;
          case "ClassPage":
          title += " | Curso | Aula";
          break;
      }
      document.title = title;
    },
  },
};
</script>
